import React from 'react';
import { Typography } from '@strapi/design-system/Typography';
import ExternalLink from '@strapi/icons/ExternalLink';
import { LINK_MESSAGE, USER_IMPACT } from '../../../utils/constants';
import { IMPACT_LEVEL_COLORS } from '#shared/constants/Accessibility';
import { Content } from '../StyledComponents';
import styles from '../AccessibilityChecker.module.css';
export const Body = ({
  data
}) => {
  return /*#__PURE__*/React.createElement(Content, {
    background: "danger100",
    borderColor: "danger200",
    color: "neutral800"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "omega",
    fontWeight: "bold",
    textColor: "neutral800",
    className: styles['body-title']
  }, data.help)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    fontWeight: "semiBold",
    variant: "omega",
    textColor: "neutral800"
  }, data.description)), /*#__PURE__*/React.createElement("div", {
    className: styles['body-info-container']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    className: styles['impact-text'],
    fontWeight: "semiBold",
    variant: "pi",
    textColor: "neutral1000"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['impact-circle'],
    style: {
      backgroundColor: IMPACT_LEVEL_COLORS[data?.impact]
    }
  }), USER_IMPACT, ' ', /*#__PURE__*/React.createElement("span", {
    className: styles['body-info-level']
  }, data.impact))), /*#__PURE__*/React.createElement("a", {
    href: data.helpUrl,
    target: "_blank",
    className: styles['body-info-link-container']
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "sigma",
    fontWeight: "bold",
    textColor: "danger700"
  }, LINK_MESSAGE), /*#__PURE__*/React.createElement(ExternalLink, {
    className: styles['link-icon']
  }))));
};